import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { IProfileAgent } from "../../../@types/api-data.types";
import { AgentApi } from "../../../utils/api/Agent";
import { getImageUrl, getProfileImageUrl } from "../../../utils/helpers/common";
import { LocalStorageHelpers } from "../../../utils/helpers/localstorage.helpers";
import { clientRoutes } from "../../../utils/routes";
import Loading from "../../loading/Loading";
import "./AgentMenuDetails.scss";
import { useNavigate } from "react-router-dom";

interface ThemeColor {
  r: number;
  g: number;
  b: number;
  pixel_counts: number;
}

const AgentMenuDetails = ({
  handleClose,
  agentData,
}: {
  handleClose: any;
  agentData: IProfileAgent | null;
}) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    isLoadingSwitch: false,
  });

  const onClickSwitch = async () => {
    let userData: any = LocalStorageHelpers.getAgentData();

    setState({
      ...state,
      isLoadingSwitch: true,
    });

    let formData = new FormData();
    formData.append("switch_to_user_role", "agency");
    formData.append("user_id", userData?.agency_ref?._id || "");
    let res = await AgentApi?.switchUserProfile(formData);

    if (res?.data?.success) {
      toast.custom(
        (t) => (
          <div
            className={`switch-toast ${
              t.visible ? "animate-enter" : "animate-leave"
            }`}
          >
            <span>Switched to agency profile</span>
            <button
              onClick={() => toast.dismiss(t.id)}
              className="switch-toast-close"
            >
              ✕
            </button>
          </div>
        ),
        {
          position: "bottom-right",
          duration: 1000,
        }
      );
      navigate("/");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      toast.error(res?.data?.message || "User not switch please reload!");
    }

    setState({
      ...state,
      isLoadingSwitch: false,
    });
  };

  useEffect(() => {
    const userProfileImages = document.querySelectorAll(".user-profile-image");

    userProfileImages.forEach((profileImage) => {
      profileImage.addEventListener("error", (event: any) => {
        event.src = "images/profile-placeholder-image.png";
      });
    });
  }, []);

  const rgbToCss = (color?: ThemeColor) => {
    if (!color) return "transparent";
    return `rgb(${color.r}, ${color.g}, ${color.b})`;
  };

  return (
    <div className="agent-menu-details-container">
      <div className="header-menu-top-contain-container">
        <div className="header-profile-image">
          <img
            src={getProfileImageUrl(
              agentData?.profile_image_ref?.compressed_file_path || ""
            )}
            alt={agentData?.profile_image_ref?.file_name}
          />
        </div>
        <div className="header-menu-profile-top-contain">
          <Link to={clientRoutes.agentProfileView}>
            <button className="header-menu-profile-btn" onClick={handleClose}>
              Agent Profile
            </button>
          </Link>

          <p className="header-menu-profile-name">{`${agentData?.principal_agent_first_name} ${agentData?.principal_agent_last_name}`}</p>
          <p className="header-menu-profile-name-email">
            {agentData?.email?.slice(0, 22)}
            {agentData?.email?.length || 0 > 22 ? "..." : ""}
          </p>
        </div>
      </div>
      <div className="header-menu-profile-border"></div>
      {agentData?.is_principal_agent ? (
        <>
          <div className="header-menu-agency-contain-container">
            <div
              className="header-agency-image"
              style={{
                backgroundColor: rgbToCss(
                  agentData?.agency_ref?.theme_colors?.[0]
                ),
              }}
            >
              <img
                src={getImageUrl(
                  agentData?.agency_ref?.profile_image_ref
                    ?.original_file_path || ""
                )}
                alt={agentData?.agency_ref?.profile_image_ref?.file_name}
              />
            </div>

            <p className="header-menu-agency-name">
              {agentData?.agency_ref?.agency_trading_name}
            </p>
            <p className="header-menu-agency-email">
              {agentData?.agency_ref?.email}
            </p>

            <p className="header-menu-agency-link" onClick={onClickSwitch}>
              {state?.isLoadingSwitch ? (
                <div className="switch-loading">
                  <Loading />
                </div>
              ) : (
                " Switch to Agency Profile"
              )}
            </p>
          </div>
          <div className="header-menu-profile-border"></div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default AgentMenuDetails;
